import jQuery from 'jquery';
import {
    BestOdds, BetHandler, priceButton, pricesProvider,
} from 'rp-prices-component';
import BetslipInteracter from './shared/price/BetslipInteracter';

function initPrices() {
    const customizeSettings = jQuery.cookie('customizeSettings');
    let showPrices = false;

    try {
        showPrices = JSON.parse(customizeSettings).showPrices;
    } catch (e) {
        console.warn(e);
    }

    if (showPrices) {
        /* eslint-disable no-new */
        new BestOdds();
        new BetHandler();
        /* eslint-enable no-new */

        priceButton.activate();
        const betslipInteracter = new BetslipInteracter();
        betslipInteracter.init()
            .then(betslipFeedName => pricesProvider.init(betslipFeedName));
    }
}

export default initPrices;



// WEBPACK FOOTER //
// ./src/js/initPrices.js